(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sentopia-brand-folds"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('sentopia-brand-folds')) {
  customElements.define('sentopia-brand-folds', class extends HTMLElement {
    connectedCallback() {
      if(this.controller)return;
      this.controller=new AbortController();const signal=this.controller.signal;
      this.row=this.querySelector('[data-brand-row]');
      this.items=[...this.querySelectorAll('[data-brand-item]')];
      this.triggers=[...this.querySelectorAll('[data-brand-trigger]')];
      this.panels=[...this.querySelectorAll('[data-brand-panel]')];
      this.active=-1;this.ignoreUntil=0;
      this.finePointer=matchMedia('(hover:hover) and (pointer:fine)');
      this.mobile=matchMedia('(max-width:749px)');
      this.reducedMotion=matchMedia('(prefers-reduced-motion:reduce)');
      this.triggers.forEach((trigger,index)=>{
        trigger.addEventListener('click',event=>{event.preventDefault();clearTimeout(this.hoverTimer);this.active===index?this.close():this.open(index);},{signal});
        trigger.addEventListener('keydown',event=>{if(event.key===' '){event.preventDefault();this.active===index?this.close():this.open(index);}},{signal});
        const hover=event=>{
          if(!this.finePointer.matches||this.mobile.matches||event.pointerType!=='mouse'||performance.now()<this.ignoreUntil||this.active===index)return;
          if(this.pending===index)return;
          clearTimeout(this.hoverTimer);this.pending=index;
          this.hoverTimer=setTimeout(()=>{this.pending=-1;this.open(index);},200);
        };
        trigger.addEventListener('pointerenter',hover,{signal});
        trigger.addEventListener('pointermove',hover,{signal});
        trigger.addEventListener('pointerleave',()=>{clearTimeout(this.hoverTimer);this.pending=-1;},{signal});
        trigger.addEventListener('pointerdown',event=>{if(event.pointerType==='touch')this.touchBrowsing=true;},{passive:true,signal});
      });
      this.addEventListener('pointerenter',()=>clearTimeout(this.leaveTimer),{signal});
      this.addEventListener('pointerleave',event=>{
        clearTimeout(this.hoverTimer);this.pending=-1;
        if(event.pointerType==='mouse'&&!this.mobile.matches)this.leaveTimer=setTimeout(()=>this.close(),180);
      },{signal});
      this.row.addEventListener('scroll',()=>{
        if(!this.mobile.matches||!this.touchBrowsing)return;
        clearTimeout(this.swipeTimer);
        this.swipeTimer=setTimeout(()=>{
          const left=this.row.getBoundingClientRect().left+10;
          const distances=this.items.map(item=>Math.abs(item.getBoundingClientRect().left-left));
          this.open(distances.indexOf(Math.min(...distances)));
        },160);
      },{passive:true,signal});
      this.panels.forEach(panel => {
        const rail = panel.querySelector('[data-product-rail]');
        const prev = panel.querySelector('[data-rail-prev]');
        const next = panel.querySelector('[data-rail-next]');
        const update = () => {
          const max = rail.scrollWidth - rail.clientWidth;
          prev.disabled = rail.scrollLeft < 3;
          next.disabled = rail.scrollLeft >= max - 3;
        };
        const move = direction => rail.scrollBy({left:direction * (rail.clientWidth * .85),behavior:this.reducedMotion.matches?'instant':'smooth'});
        prev.addEventListener('click', () => move(-1), {signal});
        next.addEventListener('click', () => move(1), {signal});
        panel.querySelector('[data-close]').addEventListener('click', () => this.close(true), {signal});
        rail.addEventListener('scroll', update, {passive:true,signal});
        rail.addEventListener('keydown', event => {
          if (event.target !== rail) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();move(event.key === 'ArrowRight'?1:-1);}
        }, {signal});
        let drag = null, dragged = false;
        rail.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          drag = {x:event.clientX,y:event.clientY,left:rail.scrollLeft,id:event.pointerId};
          dragged = false;
        }, {signal});
        rail.addEventListener('pointermove', event => {
          if (!drag) return;
          const dx=event.clientX-drag.x;
          if (!dragged && Math.abs(dx)>8 && Math.abs(dx)>Math.abs(event.clientY-drag.y)) {
            dragged=true;rail.classList.add('is-dragging');rail.setPointerCapture(drag.id);
          }
          if (dragged) {event.preventDefault();rail.scrollLeft=drag.left-dx;}
        }, {signal});
        const endDrag = () => {drag=null;rail.classList.remove('is-dragging');};
        rail.addEventListener('pointerup', endDrag, {signal});
        rail.addEventListener('pointercancel', endDrag, {signal});
        rail.addEventListener('lostpointercapture', endDrag, {signal});
        rail.addEventListener('pointerleave', () => {if(!dragged)drag=null;}, {signal});
        rail.addEventListener('dragstart', event => event.preventDefault(), {signal});
        rail.addEventListener('click', event => {if(dragged){event.preventDefault();event.stopPropagation();dragged=false;}}, {capture:true,signal});
        panel.updateRail = update;
      });

      this.addEventListener('keydown',event=>{if(event.key==='Escape'&&this.active>=0){event.preventDefault();this.close(true);}},{signal});
      document.addEventListener('pointerdown',event=>{if(!this.contains(event.target))this.close();},{signal});
      window.addEventListener('resize',()=>{if(this.active>=0)this.panels[this.active].updateRail();},{signal});
      this.observer=new ResizeObserver(()=>{if(this.active>=0)this.panels[this.active].updateRail();});this.observer.observe(this.row);
    }
    open(index) {
      if(this.active===index)return;
      clearTimeout(this.leaveTimer);this.ignoreUntil=performance.now()+650;this.active=index;
      this.row.classList.add('has-open');
      this.items.forEach((item,i)=>item.classList.toggle('is-active',i===index));
      this.triggers.forEach((trigger,i)=>trigger.setAttribute('aria-expanded',String(i===index)));
      this.panels.forEach((panel,i)=>panel.hidden=i!==index);
      requestAnimationFrame(()=>this.panels[index].updateRail());
    }
    close(restoreFocus=false) {
      const previous=this.active;clearTimeout(this.hoverTimer);clearTimeout(this.swipeTimer);this.pending=-1;this.touchBrowsing=false;
      this.active=-1;this.ignoreUntil=performance.now()+650;this.row.classList.remove('has-open');
      this.items.forEach(item=>item.classList.remove('is-active'));
      this.panels.forEach(panel=>panel.hidden=true);
      this.triggers.forEach(trigger=>trigger.setAttribute('aria-expanded','false'));
      if(restoreFocus&&previous>=0)this.triggers[previous].focus({preventScroll:true});
    }
    disconnectedCallback(){clearTimeout(this.hoverTimer);clearTimeout(this.leaveTimer);clearTimeout(this.swipeTimer);this.observer?.disconnect();this.controller?.abort();this.controller=null;}
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sentopia-brand-rails"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sentopia-brand-rails')) {
  customElements.define('sentopia-brand-rails', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.triggers = [...this.querySelectorAll('[data-brand-trigger]')];
      this.panels = [...this.querySelectorAll('[data-brand-panel]')];
      this.active = -1;
      this.finePointer = matchMedia('(hover:hover) and (pointer:fine)');
      this.reducedMotion = matchMedia('(prefers-reduced-motion:reduce)');
      this.brandTrack = this.querySelector('[data-brand-track]');
      this.brandPrevious = this.querySelector('[data-brand-prev]');
      this.brandNext = this.querySelector('[data-brand-next]');
      this.brandPosition = this.querySelector('[data-brand-position]');
      this.htmlCache = new Map();
      this.loadedPanels = [];
      this.bannerObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {if(entry.isIntersecting){this.loadBanner(entry.target);this.bannerObserver.unobserve(entry.target);}});
      }, {root:this.brandTrack,rootMargin:'0px 35% 0px 35%'});
      this.sectionObserver = new IntersectionObserver(entries => {
        if (!entries.some(entry=>entry.isIntersecting)) return;
        this.querySelectorAll('[data-banner-src]').forEach(img=>this.bannerObserver.observe(img));
        this.sectionObserver.disconnect();
        if(this.active < 0 && this.triggers.length)this.open(0);
      }, {rootMargin:'600px 0px'});
      this.sectionObserver.observe(this);
      this.brandPrevious.addEventListener('click', () => this.selectBrand(this.active - 1), {signal});
      this.brandNext.addEventListener('click', () => this.selectBrand(this.active + 1), {signal});
      this.brandTrack.addEventListener('keydown', event => {
        if (event.target !== this.brandTrack && !event.target.matches('[data-brand-trigger]')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.selectBrand(this.active + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, {signal});
      const resumeManualScroll = () => {this.targetBrand = null;clearTimeout(this.brandSettleTimer);};
      this.brandTrack.addEventListener('pointerdown', resumeManualScroll, {signal});
      this.brandTrack.addEventListener('wheel', resumeManualScroll, {passive:true,signal});
      this.brandTrack.addEventListener('scroll', () => {
        clearTimeout(this.hoverTimer);
        clearTimeout(this.brandSettleTimer);
        this.brandScrolling = true;
        if (!this.brandFrame) this.brandFrame = requestAnimationFrame(() => {
          this.brandFrame = null;
          if (this.targetBrand == null) this.open(this.nearestBrand());
        });
        this.brandSettleTimer = setTimeout(() => {
          this.brandScrolling = false;
          this.targetBrand = null;
        }, 180);
      }, {passive:true,signal});
      let brandDrag = null, brandDragged = false;
      this.brandTrack.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        brandDrag = {x:event.clientX,y:event.clientY,left:this.brandTrack.scrollLeft,id:event.pointerId};
        brandDragged = false;
      }, {signal});
      this.brandTrack.addEventListener('pointermove', event => {
        if (!brandDrag) return;
        const dx = event.clientX - brandDrag.x;
        if (!brandDragged && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(event.clientY-brandDrag.y)) {
          brandDragged = true;
          clearTimeout(this.hoverTimer);
          this.brandTrack.classList.add('is-dragging');
          this.brandTrack.setPointerCapture(brandDrag.id);
        }
        if (brandDragged) {event.preventDefault();this.brandTrack.scrollLeft=brandDrag.left-dx;}
      }, {signal});
      const finishBrandDrag = () => {
        brandDrag = null;
        this.brandTrack.classList.remove('is-dragging');
        if (brandDragged) this.open(this.nearestBrand());
      };
      this.brandTrack.addEventListener('pointerup', finishBrandDrag, {signal});
      this.brandTrack.addEventListener('pointercancel', finishBrandDrag, {signal});
      this.brandTrack.addEventListener('lostpointercapture', finishBrandDrag, {signal});
      this.brandTrack.addEventListener('pointerleave', () => {if(!brandDragged)brandDrag=null;}, {signal});
      this.brandTrack.addEventListener('dragstart', event => event.preventDefault(), {signal});
      this.brandTrack.addEventListener('click', event => {
        if (brandDragged) {event.preventDefault();event.stopPropagation();brandDragged=false;}
      }, {capture:true,signal});
      this.triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', event => {
          event.preventDefault();
          clearTimeout(this.hoverTimer);
          this.selectBrand(index);
        }, {signal});
        trigger.addEventListener('pointerenter', event => {
          clearTimeout(this.hoverTimer);
          if (this.finePointer.matches && event.pointerType === 'mouse' && !this.brandScrolling && !brandDrag) {
            this.hoverTimer = setTimeout(() => {if(!this.brandScrolling && !brandDrag)this.open(index);}, 220);
          }
        }, {signal});
        trigger.addEventListener('pointerleave', () => clearTimeout(this.hoverTimer), {signal});
      });
      this.panels.forEach(panel => {
        const rail = panel.querySelector('[data-product-rail]');
        panel.placeholder = rail.querySelector('[role="status"]')?.outerHTML || '';
        if(panel.dataset.loaded==='true')this.loadedPanels.push(panel);
        const prev = panel.querySelector('[data-rail-prev]');
        const next = panel.querySelector('[data-rail-next]');
        const update = () => {
          const max = rail.scrollWidth - rail.clientWidth;
          prev.disabled = rail.scrollLeft < 3;
          next.disabled = rail.scrollLeft >= max - 3;
        };
        const move = direction => rail.scrollBy({left:direction * (rail.clientWidth * .85),behavior:this.reducedMotion.matches?'instant':'smooth'});
        prev.addEventListener('click', () => move(-1), {signal});
        next.addEventListener('click', () => move(1), {signal});
        panel.querySelector('[data-close]').addEventListener('click', () => this.close(true), {signal});
        rail.addEventListener('scroll', update, {passive:true,signal});
        rail.addEventListener('keydown', event => {
          if (event.target !== rail) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();move(event.key === 'ArrowRight'?1:-1);}
        }, {signal});
        let drag = null, dragged = false;
        rail.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          drag = {x:event.clientX,y:event.clientY,left:rail.scrollLeft,id:event.pointerId};
          dragged = false;
        }, {signal});
        rail.addEventListener('pointermove', event => {
          if (!drag) return;
          const dx=event.clientX-drag.x;
          if (!dragged && Math.abs(dx)>8 && Math.abs(dx)>Math.abs(event.clientY-drag.y)) {
            dragged=true;rail.classList.add('is-dragging');rail.setPointerCapture(drag.id);
          }
          if (dragged) {event.preventDefault();rail.scrollLeft=drag.left-dx;}
        }, {signal});
        const endDrag = () => {drag=null;rail.classList.remove('is-dragging');};
        rail.addEventListener('pointerup', endDrag, {signal});
        rail.addEventListener('pointercancel', endDrag, {signal});
        rail.addEventListener('lostpointercapture', endDrag, {signal});
        rail.addEventListener('pointerleave', () => {if(!dragged)drag=null;}, {signal});
        rail.addEventListener('dragstart', event => event.preventDefault(), {signal});
        rail.addEventListener('click', event => {if(dragged){event.preventDefault();event.stopPropagation();dragged=false;}}, {capture:true,signal});
        panel.updateRail = update;
      });
      this.addEventListener('keydown', event => {if(event.key==='Escape' && this.active>=0){event.preventDefault();this.close(true);}}, {signal});
      window.addEventListener('resize', () => {if(this.active>=0)this.panels[this.active].updateRail();}, {signal});
      // Open the first product rail when the section approaches the viewport.
    }
    loadBanner(img) {
      if(!img?.dataset.bannerSrc)return;
      img.srcset=img.dataset.bannerSrcset;
      img.src=img.dataset.bannerSrc;
      delete img.dataset.bannerSrc;
      delete img.dataset.bannerSrcset;
    }
    cacheHtml(key,html) {
      this.htmlCache.delete(key);
      this.htmlCache.set(key,html);
      while(this.htmlCache.size>6)this.htmlCache.delete(this.htmlCache.keys().next().value);
    }
    async loadProducts(panel) {
      if(panel.dataset.loaded==='true')return;
      this.pendingRequest?.abort();
      const request=new AbortController();
      this.pendingRequest=request;
      const rail=panel.querySelector('[data-product-rail]');
      rail.setAttribute('aria-busy','true');
      try {
        let html=this.htmlCache.get(panel.dataset.productsUrl);
        if(!html){
          const response=await fetch(panel.dataset.productsUrl,{credentials:'same-origin',signal:request.signal});
          if(!response.ok)throw new Error('Section unavailable');
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');
          const content=doc.querySelector('[data-vitrina-content]');
          if(!content)throw new Error('Section missing');
          html=content.innerHTML;
        }
        if(request.signal.aborted)return;
        this.cacheHtml(panel.dataset.productsUrl,html);
        rail.innerHTML=html;
        panel.dataset.loaded='true';
        this.loadedPanels=this.loadedPanels.filter(p=>p!==panel);
        this.loadedPanels.push(panel);
        while(this.loadedPanels.length>3){
          const previous=this.loadedPanels.shift();
          const previousRail=previous.querySelector('[data-product-rail]');
          if(!this.htmlCache.has(previous.dataset.productsUrl))this.cacheHtml(previous.dataset.productsUrl,previousRail.innerHTML);
          previousRail.innerHTML=previous.placeholder;
          previous.dataset.loaded='false';
        }
        requestAnimationFrame(()=>panel.updateRail());
      } catch(error) {
        if(error.name==='AbortError')return;
        const status=document.createElement('div');
        status.className='sp-vitrinas__load-status';
        status.setAttribute('role','status');
        const message=document.createElement('span');
        message.textContent=this.dataset.loadError;
        const retry=document.createElement('button');
        retry.type='button';retry.textContent=this.dataset.retryLabel;
        retry.addEventListener('click',()=>this.loadProducts(panel),{once:true});
        status.append(message,retry);rail.replaceChildren(status);
      } finally {rail.removeAttribute('aria-busy');}
    }
    nearestBrand() {
      const trackLeft = this.brandTrack.getBoundingClientRect().left + parseFloat(getComputedStyle(this.brandTrack).paddingLeft || 0);
      let nearest = 0, distance = Infinity;
      this.triggers.forEach((trigger,index) => {
        const delta = Math.abs(trigger.closest('.sp-vitrinas__banner').getBoundingClientRect().left-trackLeft);
        if (delta < distance) {distance=delta;nearest=index;}
      });
      return nearest;
    }
    selectBrand(index) {
      index = Math.max(0,Math.min(this.triggers.length-1,index));
      clearTimeout(this.hoverTimer);
      this.brandScrolling = true;
      this.targetBrand = index;
      this.open(index);
      const banner = this.triggers[index].closest('.sp-vitrinas__banner');
      const left = this.brandTrack.scrollLeft + banner.getBoundingClientRect().left - this.brandTrack.getBoundingClientRect().left - parseFloat(getComputedStyle(this.brandTrack).paddingLeft || 0);
      this.brandTrack.scrollTo({left,behavior:this.reducedMotion.matches?'instant':'smooth'});
      clearTimeout(this.brandSettleTimer);
      this.brandSettleTimer = setTimeout(() => {this.targetBrand=null;this.brandScrolling=false;}, 800);
    }
    open(index) {
      if(this.active===index || !this.panels[index]) return;
      this.active=index;
      this.brandPrevious.disabled = index === 0;
      this.brandNext.disabled = index === this.triggers.length-1;
      this.brandPosition.textContent = `${index+1} / ${this.triggers.length}`;
      this.triggers.forEach((trigger,i)=>{trigger.setAttribute('aria-expanded',String(i===index));trigger.closest('.sp-vitrinas__banner').classList.toggle('is-active',i===index);});
      this.panels.forEach((panel,i)=>{panel.hidden=i!==index;});
      this.loadBanner(this.triggers[index].querySelector('img'));
      clearTimeout(this.loadTimer);
      this.pendingRequest?.abort();
      this.loadTimer=setTimeout(()=>{if(this.active===index)this.loadProducts(this.panels[index]);},180);
      requestAnimationFrame(()=>this.panels[index].updateRail());
    }
    close(restoreFocus=false) {
      const previous=this.active;
      clearTimeout(this.hoverTimer);
      clearTimeout(this.loadTimer);
      this.pendingRequest?.abort();
      this.active=-1;
      this.panels.forEach(panel=>{panel.hidden=true;});
      this.triggers.forEach(trigger=>{trigger.setAttribute('aria-expanded','false');trigger.closest('.sp-vitrinas__banner').classList.remove('is-active');});
      if(restoreFocus && previous>=0)this.triggers[previous].focus({preventScroll:true});
    }
    disconnectedCallback() {clearTimeout(this.hoverTimer);clearTimeout(this.loadTimer);clearTimeout(this.brandSettleTimer);cancelAnimationFrame(this.brandFrame);this.pendingRequest?.abort();this.bannerObserver?.disconnect();this.sectionObserver?.disconnect();this.controller?.abort();this.controller=null;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sentopia-collection-gallery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sentopia-collection-gallery')){
  customElements.define('sentopia-collection-gallery',class extends HTMLElement{
    connectedCallback(){
      if(this.abort)return;
      this.rail=this.querySelector('.spcg-rail');
      this.previous=this.querySelector('[data-direction="-1"]');
      this.next=this.querySelector('[data-direction="1"]');
      this.thumb=this.querySelector('.spcg-track span');
      this.abort=new AbortController();
      const signal=this.abort.signal;
      this.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>{
        const distance=this.rail.children[0].getBoundingClientRect().width*Number(button.dataset.direction);
        this.rail.scrollBy({left:distance,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      },{signal}));
      this.rail.addEventListener('pointerdown',event=>{
        if(event.pointerType!=='mouse'||event.button!==0)return;
        this.blockDragClick=false;
        if(this.rail.scrollWidth<=this.rail.clientWidth)return;
        this.drag={id:event.pointerId,x:event.clientX,y:event.clientY,left:this.rail.scrollLeft,active:false};
        this.rail.classList.add('is-pointer-down');
      },{signal});
      window.addEventListener('pointermove',event=>{
        const drag=this.drag;
        if(!drag||event.pointerId!==drag.id)return;
        if(!(event.buttons&1)){this.endDrag();return;}
        const distance=event.clientX-drag.x;
        if(!drag.active){
          if(Math.max(Math.abs(distance),Math.abs(event.clientY-drag.y))<6)return;
          if(Math.abs(event.clientY-drag.y)>Math.abs(distance)){this.endDrag();return;}
          drag.active=true;
          this.rail.classList.add('is-dragging');
          this.rail.setPointerCapture(drag.id);
        }
        event.preventDefault();
        this.rail.scrollLeft=drag.left-distance;
      },{passive:false,signal});
      ['pointerup','pointercancel'].forEach(type=>window.addEventListener(type,event=>{
        if(this.drag?.id===event.pointerId)this.endDrag();
      },{signal}));
      this.rail.addEventListener('lostpointercapture',event=>{
        if(this.drag?.id===event.pointerId)this.endDrag();
      },{signal});
      window.addEventListener('blur',()=>this.endDrag(),{signal});
      this.rail.addEventListener('dragstart',event=>{
        if(this.drag)event.preventDefault();
      },{signal});
      this.rail.addEventListener('click',event=>{
        if(!this.blockDragClick||event.detail===0)return;
        event.preventDefault();
        event.stopPropagation();
        this.blockDragClick=false;
      },{capture:true,signal});
      this.rail.addEventListener('scroll',()=>this.update(),{passive:true,signal});
      this.observer=new ResizeObserver(()=>this.update());this.observer.observe(this.rail);this.update();
    }
    endDrag(){
      const drag=this.drag;
      if(!drag)return;
      this.drag=null;
      this.blockDragClick=drag.active;
      this.rail.classList.remove('is-pointer-down','is-dragging');
      if(this.rail.hasPointerCapture(drag.id))this.rail.releasePointerCapture(drag.id);
      this.update();
    }
    update(){
      if(!this.thumb)return;
      const width=this.rail.clientWidth,total=this.rail.scrollWidth,position=Math.abs(this.rail.scrollLeft),maximum=Math.max(0,total-width);
      this.previous.disabled=position<2;this.next.disabled=position>=maximum-2;
      this.thumb.style.width=(100*width/total)+'%';
      this.thumb.style.left=(100*position/total)+'%';
    }
    disconnectedCallback(){this.endDrag();this.abort?.abort();this.observer?.disconnect();this.abort=null;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sentopia-family-deck"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sentopia-family-deck')) {
  customElements.define('sentopia-family-deck', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.cards = Array.from(this.querySelectorAll('[data-family-card]'));
      this.choices = Array.from(this.querySelectorAll('[data-family-choice]'));
      this.deck = this.querySelector('.sp-families__deck');
      this.mobile = window.matchMedia('(max-width:749px)');
      this.reduced = window.matchMedia('(prefers-reduced-motion:reduce)');
      this.current = Math.min(Number(this.dataset.start) || 0, this.cards.length - 1);
      if (!this.cards.length) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.querySelector('.sp-families__explorer').hidden = false;
      this.querySelector('.sp-families__controls').hidden = false;
      this.dataset.ready = '';
      this.choices.forEach((button, i) => button.addEventListener('click', () => this.select(i, true), {signal}));
      this.querySelector('[data-prev]').addEventListener('click', () => this.select(this.current - 1, true), {signal});
      this.querySelector('[data-next]').addEventListener('click', () => this.select(this.current + 1, true), {signal});
      this.deck.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.select(this.current + (event.key === 'ArrowRight' ? 1 : -1), true);
      }, {signal});
      this.deck.addEventListener('scroll', () => {
        if (!this.mobile.matches) return;
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          const center = this.deck.scrollLeft + this.deck.clientWidth / 2;
          let nearest = 0, distance = Infinity;
          this.cards.forEach((card, i) => {
            const next = Math.abs(card.offsetLeft + card.offsetWidth / 2 - center);
            if (next < distance) { distance = next; nearest = i; }
          });
          this.select(nearest, false);
        }, 120);
      }, {passive:true,signal});
      this.mobile.addEventListener('change', () => this.select(this.current, true, false), {signal});
      this.select(this.current, true, false);
    }
    select(index, move, animate = true) {
      this.current = (index + this.cards.length) % this.cards.length;
      this.cards.forEach((card, i) => {
        const difference = (i - this.current + this.cards.length) % this.cards.length;
        const position = difference === 0 ? 'current' : difference === 1 ? 'next' : difference === this.cards.length - 1 ? 'previous' : 'hidden';
        card.dataset.position = position;
        const hidden = !this.mobile.matches && position === 'hidden';
        card.toggleAttribute('inert', hidden);
        if (hidden) card.setAttribute('aria-hidden', 'true'); else card.removeAttribute('aria-hidden');
        this.choices[i].setAttribute('aria-pressed', String(i === this.current));
      });
      const card = this.cards[this.current];
      this.querySelector('[data-family-title]').textContent = card.dataset.label;
      this.querySelector('[data-family-description]').textContent = card.dataset.description;
      const cta = this.querySelector('[data-family-link]');
      cta.href = card.href;
      cta.setAttribute('aria-label', card.getAttribute('aria-label'));
      this.querySelector('[data-count]').textContent = String(this.current + 1);
      if (move && this.mobile.matches) {
        this.deck.scrollTo({left:card.offsetLeft - (this.deck.clientWidth - card.offsetWidth) / 2,behavior:animate && !this.reduced.matches ? 'smooth' : 'instant'});
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      clearTimeout(this.scrollTimer);
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
